import * as S from './ErrorMessage.styles'

export default ({ message }) => (
  <S.ErrorMessage>
    {message}
  </S.ErrorMessage>
)
